<ng-container *ngIf="isAuth; else noAuthToolbar">
  <mat-toolbar color="primary">
    <mat-toolbar-row>
      <h1>{{ 'application.name-' + environmentName | translate }}</h1>
      <span class="menu-spacer"></span>
      <div class="toolbar-container">
      </div>
      <div class="toolbar-container-end">

        <app-error-counter></app-error-counter>

        <mat-divider class="toolbar-divider" [vertical]="true"></mat-divider>

        <div class="toolbar-user">
          <mat-icon style="margin-right: 5px;">person</mat-icon>
          <span>{{ currentUser?.firstName }} {{ currentUser?.lastName }}</span>
        </div>
        <!-- <mat-divider class="toolbar-divider" [vertical]="true"></mat-divider>
        <button mat-mini-fab style="margin-right: 10px;" (click)="useLanguage('fr')" type="button">Fr</button>
        <button mat-mini-fab (click)="useLanguage('en')" type="button">En</button> -->
        <mat-divider class="toolbar-divider" [vertical]="true"></mat-divider>
        <button mat-raised-button color="accent" (click)="logout()">{{ 'button.logout' | translate }}</button>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>
</ng-container>
<ng-template #noAuthToolbar>
  <mat-toolbar>
    <mat-toolbar-row>
      <div class="toolbar-container-end">
        <!-- <button mat-mini-fab style="margin-right: 10px;" (click)="useLanguage('fr')" type="button">Fr</button>
        <button mat-mini-fab (click)="useLanguage('en')" type="button">En</button> -->
      </div>
    </mat-toolbar-row>
  </mat-toolbar>
</ng-template>